export var IDENTITY_REPOSITORY_WEB_CONFIG = 'IDENTITY_REPOSITORY_WEB_CONFIG';